module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/082-united-nations-8d54b61e44b505651e66e86c2c0afd53.svg";